import ClubPerformanceBasicRoutes from "./ClubPerformanceBasicRoutes";

import LoadingModal from "@usas/ui-web/components/dialogs/LoadingModal";

import useNavRoutes from "@usas/ui-web/state/security/UseNavRoutes";

const ClubPerformance = () => {
  const { navRoutes, isReadyToRoute } = useNavRoutes();

  if (isReadyToRoute !== true) {
    return <LoadingModal />;
  }

  return <ClubPerformanceBasicRoutes navRoutes={navRoutes} />;
};

export default ClubPerformance;